module.exports = __webpack_public_path__ + "img/negative.a110c90c.svg";